export default __webpack_public_path__ + "static/media/pic01.119fc3b6.jpg";